import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { DeclarationOfOwnershipSignerInfoDto, DeclarationOfOwnershipSignerInfoValidator } from 'dtos/people'
import { Form, Formik } from 'formik'

interface Props {
  initialValues: DeclarationOfOwnershipSignerInfoDto
  loading: boolean
  onClose: () => void
  onSave: (values: DeclarationOfOwnershipSignerInfoDto) => void
  open: boolean
}

export default function DeclarationOfOwnershipSignerEditDialog({ initialValues, loading, onClose, onSave, open }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={DeclarationOfOwnershipSignerInfoValidator}
      >
        {({ errors, isSubmitting, setFieldValue, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit Declaration of Ownership Signer</DialogTitle>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='fileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('declarationOfOwnershipSignerSignatureFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button disabled={loading || isSubmitting} onClick={() => document.getElementById('fileInput')?.click()} variant='contained'>
                      UPLOAD SIGNATURE
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.declarationOfOwnershipSignerSignatureFile?.name ?? values.declarationOfOwnershipSignerSignatureFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.declarationOfOwnershipSignerSignatureFile && (
                      <Typography color='error' variant='body2'>
                        {errors.declarationOfOwnershipSignerSignatureFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`All fields are required.

Signature must be uploaded to save.

Image formats accepted: .PNG, .JPG or .JPEG

Maximum files size for upload up 20Mbs`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
